import { createContext } from 'react'

const DraggedItemHeightContext = createContext<number>(0)

export default DraggedItemHeightContext
